module.exports = __webpack_public_path__ + "static/img/englishlogo.fa9c9ab.png";